<template>
  <div
    :class="[getCustomClass(data)]"
    :title="getTitle(data)"
    :style="{ left: `${getPositionByTime(data)}%`, width: data.width }">
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import dateFormatter from '@/utils/dateFormatter';

export default {
  mixins: [dateFormatter],
  props: {
    data: {
      type: Object,
      default: () => {},
    },
    typeTimeline: {
      type: String,
      default: '',
    },
  },
  computed: {
    ...mapGetters(['firstEvent', 'playbackDuration']),
  },
  methods: {
    prettyFormatOfEventType(type) {
      const regex = /playback./gi;
      return type.replace(regex, '');
    },
    getCustomClass(data) {
      if (this.typeTimeline === 'resolution' && data.playback_resolution) {
        return `resolution res-${data.playback_resolution}`;
      }
      return '';
    },
    getTitle(data) {
      if (this.typeTimeline === 'resolution') {
        return `${data.playback_resolution}, event : ${this.prettyFormatOfEventType(data.type)} ${this.formatLongDateTime(data.client_timestamp)}`;
      }
      return `${this.prettyFormatOfEventType(data.type)} ${this.formatLongDateTime(data.client_timestamp)}`;
    },
    getPositionByTime(event) {
      return (((event.client_timestamp - this.firstEvent.client_timestamp) / this.playbackDuration) * 100).toFixed(2);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';

.resolution {
  border-radius: 0;
  flex: 1;
  width: auto !important;
  /*
  '#4CAFE1',
  '#76BAE3',
  '#96C5E4',
  '#B3D1E6',
  '#CEDCE7',
  '#E8E8E8',
  '#EDDBC0',
  '#EFCE99',
  '#EFC172',
  '#EBB447',
  '#E6A800',
  */

  &.res-720p {
    background-color: darken(#4CAFE1, 10%);
  }

  &.res-480p {
    background-color: #4CAFE1;
  }

  &.res-360p {
    background-color: ligthen(#4CAFE1, 10%);
  }

  &.res-240p {
    background-color: lighten(#4CAFE1, 20%);
  }

  &.res-144p {
    background-color: lighten(#4CAFE1, 30%);
  }
}
</style>
